export const CONFIG = {
  //baseUrl: 'http://192.168.100.5:9000',
  //apiUrl: 'http://192.168.100.5:9000/api',
  baseUrl: 'http://23.131.184.92:9002',
  //ws: 'ws://192.168.100.5:9000',
  ws: 'ws://23.131.184.92:9002',
};
